import { useState, useEffect } from "react";
import "./ComoComprar.css";
import Imagens from "../../components/IMAGESCOMPONENT/ImageComponent";
import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";

export default function ComoComprar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
      window.scrollTo({ top: 0 });
    }, []);

  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />


    
          <div className="content-image">
            <img src={Imagens.ComoComprar1} alt="Grupo Delly's" />
          </div>
          <div className="content-image">
            <img src={Imagens.ComoComprar2} alt="Grupo Delly's" />
          </div>
          <div className="content-image">
            <img src={Imagens.ComoComprar3} alt="Grupo Delly's" />
          </div>
          <div className="content-image">
            <img src={Imagens.ComoComprar4} alt="Grupo Delly's" />
          </div>
          <div className="content-image">
            <img src={Imagens.ComoComprar5} alt="Grupo Delly's" />
          </div>

 
    </>
  );
}
